import React from "react";
import "./style.scss";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import styles from "./DispatchPickupPopupStyles";
import Tooltip from "@material-ui/core/Tooltip";
import Button from "@material-ui/core/Button";
import { postData } from "../../../api/componentAPIs";
import {
  formatAddress,
} from "../../modules/Dispatch/utils/utils";
import EditIcon from "@material-ui/icons/Edit";
import SelectPickupTerminal from "./SelectPickupTerminal";
import { trackEvent } from "../../common/AppInsightsEventTracking";
import { getSpecialNeeds } from "../../dataGrid/cellRenderer";
import SpecialNeeds from "./DispatchMap/components/Content/SpecialNeeds"
import Contact from "./DispatchMap/components/Contact";

class DispatchUnassignedPickupPopupInfo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      terminalAnchorEl: null,
    };
  }

  handleTerminalClick = (event) => {
    trackEvent("ChangePickupTerminalIconClick", this.props.userProfile, {
      pickupId: this.props.data.pickupId,
    });
    this.setState({ terminalAnchorEl: event.currentTarget });
  };

  handleTerminalClose = () => {
    this.setState({ terminalAnchorEl: null });
  };

  handleTerminalChange = (value) => {
    const {
      data: { data },
    } = this.props;
    this.setState({ terminalAnchorEl: null });
    this.props.glEventHub.emit("DispatchEvents", "ShowLoaderDialog", [
      "Pickup terminal change",
    ]);
    const requestObj = {
      pickupId: data.pickupId,
      terminalCode: this.props.activeTerminal,
      toTerminal: value,
    };
    trackEvent("ChangePickupTerminal", this.props.userProfile, requestObj);
    postData("UpdatePickupTerminal", requestObj).then((response) => {
      if (!response && response.status < 200 && response.status > 400) {
        this.props.glEventHub.emit("DispatchEvents", "HideLoaderDialog", []);
        this.props.enqueueSnackbar(
          "An error occurred while changing the pickup terminal. Please try again later.",
          { variant: "error" }
        );
      }
    });
  };

  getShipperContactDetails = (pickup) => {
    return {
      name: pickup?.shipperContactName ?? "",
      phoneNumber: pickup?.shipperPhoneNumber === "0" ? "" : pickup?.shipperPhoneNumber ?? "",
    };
  };

  render() {
    const {
      classes,
      theme,
      onButtonClicked,
      hideAction,
      data: { data },
      terminalOptions,
      activeTerminal,
      hideTerminalChange,
      markerComponent,
      specialNeeds,
    } = this.props;
    const address = formatAddress({
      address: data?.shipperAddress,
      city: data?.shipperCity,
      state: data?.shipperState,
      zip: data?.shipperZip,
    });
    const specialNeedsValues = getSpecialNeeds({data});

    return (
      <Paper className={`popupBGColor ${classes.popupContainer}`}>
        <Table className={classes.table} padding="none">
          <TableHead className={classes.tableHead}>
            <TableRow className={classes.tableHeadHeight}>
              <TableCell colSpan={2}>
                <div className={classes.tableStopHeaderCell}>
                  <span
                    className={classes.pickupMarker}
                    style={{ float: "left" }}
                  >
                    {markerComponent}
                  </span>

                  <span className={classes.tableHeaderCell}>
                    <Tooltip
                      classes={{
                        popper: "popper",
                        tooltip: `tooltip-${theme}`,
                      }}
                      title={data.shipperName}
                    >
                      <span className={classes.customerName}>
                        {data.shipperName}
                      </span>
                    </Tooltip>
                    <Tooltip
                      classes={{
                        popper: "popper",
                        tooltip: `tooltip-${theme}`,
                      }}
                      title={`#${data.pickupNumber}`}
                    >
                      <span
                        className={classes.accountNumber}
                      >{`#${data.pickupNumber}`}</span>
                    </Tooltip>
                    <div>
                      <Tooltip
                        classes={{
                          popper: "popper",
                          tooltip: `tooltip-${theme}`,
                        }}
                        title={address}
                      >
                        <div className={classes.address}>{address}</div>
                      </Tooltip>
                    </div>
                    {hideTerminalChange ? (
                      <div className={classes.TerminalClickClass}>
                        <span className={classes.terminalName}>
                          {activeTerminal}
                        </span>
                      </div>
                    ) : (
                      <div
                        className={classes.TerminalClickClass}
                        onClick={this.handleTerminalClick}
                      >
                        <span className={classes.terminalName}>
                          {activeTerminal}
                        </span>
                        <EditIcon className={classes.editIcon} />
                      </div>
                    )}
                  </span>
                </div>
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            <Contact {...this.getShipperContactDetails(data)}/>
            <TableRow className={classes.tableRowRoot}>
              <TableCell className={`${classes.labelCell}  tableCellName`}>
                Spl Needs
              </TableCell>
              <TableCell
                align="right"
                className={`${classes.dataCell} ${classes.popupDataStyle} tableCellValue`}
              >
                <SpecialNeeds
                  specialNeeds={specialNeeds}
                  values={specialNeedsValues}
                  stopData={data}
                />
              </TableCell>
            </TableRow>
            <TableRow className={classes.tableRowRoot}>
              <TableCell
                className={`${classes.nameCellPadding} ${classes.labelCell}  tableCellName`}
              >
                <div className={classes.dualCellLeft}>HU</div>
                <div className={classes.dualCellRight}>Weight</div>
              </TableCell>
              <TableCell
                align="right"
                className={`${classes.dataCell} ${classes.popupDataStyle}  tableCellValue`}
              >
                <div className={classes.dualCellLeft}>{data.hu}</div>
                <div className={classes.dualCellRight}>
                  {data.weight ? `${data.weight} lbs` : "N/A"}
                </div>
              </TableCell>
            </TableRow>
            <TableRow className={classes.tableRowRoot}>
              <TableCell className={`${classes.labelCell}  tableCellName`}>
                Pieces
              </TableCell>
              <TableCell
                align="right"
                className={`${classes.dataCell} ${classes.popupDataStyle} tableCellValue`}
              >
                {data.pieces}
              </TableCell>
            </TableRow>
            <TableRow className={classes.tableRowRoot}>
              <TableCell
                className={`${classes.nameCellPadding} ${classes.labelCell} ${classes.lastTableCell} tableCellName`}
              >
                <div className={classes.dualCellLeft}>Ready</div>
                <div className={classes.dualCellRight}>Close Time</div>
              </TableCell>
              <TableCell
                align="right"
                className={`${classes.dataCell}  ${classes.lastTableCell} tableCellValue`}
              >
                <div className={classes.dualCellLeft}>
                  {data.pickupReadyTime}
                </div>
                <div className={classes.dualCellRight}>
                  {data.pickupCloseTime}
                </div>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
        {hideAction ? null : (
          <Button
            className={classes.recommendationButton}
            variant="contained"
            size="small"
            color="primary"
            onClick={() => onButtonClicked(data.pickupId)}
          >
            Show Best Drivers
          </Button>
        )}
        {this.state.terminalAnchorEl && (
          <SelectPickupTerminal
            terminalAnchor={this.state.terminalAnchorEl}
            closeTerminalMenu={this.handleTerminalClose}
            handleTerminalChange={this.handleTerminalChange}
            activeTerminal={activeTerminal}
            terminalOptions={terminalOptions}
            theme={theme}
          />
        )}
      </Paper>
    );
  }
}

export default withStyles(styles)(DispatchUnassignedPickupPopupInfo);
